export const URA_SEARCH_LOADING = 'URA_SEARCH_LOADING';
export const SET_ERROR_MESSAGES = 'SET_ERROR_MESSAGES';
export const SET_SUCCESS_MESSAGES = 'SET_SUCCESS_MESSAGES';
export const SET_URA_SERCH_FORM_VALUES = 'SET_URA_SERCH_FORM_VALUES';
export const SET_DRUG_FAMILY_TABLE_DATA = 'SET_DRUG_FAMILY_TABLE_DATA';
export const SET_DRUG_FAMILY_SELECTED_ROWS = 'SET_DRUG_FAMILY_SELECTED_ROWS';
export const GET_ALL_REBATE_PROGRAMS = 'GET_ALL_REBATE_PROGRAMS';
export const GET_MANUFACTURER_LIST = 'GET_MANUFACTURER_LIST';
export const SET_MANUFACTURER_SELECTED_ROWS = 'SET_MANUFACTURER_SELECTED_ROWS';
export const GET_URA_DETAILS_TABLE_DATA = 'GET_URA_DETAILS_TABLE_DATA';
export const URA_DETAILS_TABLE_ROW_SELECTED = 'URA_DETAILS_TABLE_ROW_SELECTED';
export const URA_SEARCH_BY_DRUG_NAME_TABLE_DATA = 'URA_SEARCH_BY_DRUG_NAME_TABLE_DATA';
export const URA_LABELER_DRUG_TABLE_DATA = 'URA_LABELER_DRUG_TABLE_DATA';
export const URA_LABELER_TABLE_DATA = 'URA_LABELER_TABLE_DATA';
export const SET_CALCULATED_URA_HEADER_DATA_LIST = 'SET_CALCULATED_URA_HEADER_DATA_LIST';
export const SET_CALCULATED_URA_HEADER_DATA = 'SET_CALCULATED_URA_HEADER_DATA';
export const SET_TOP_GRID_TABLE_DATA = 'SET_TOP_GRID_TABLE_DATA';
export const SET_CHILD_GRID_DETAIL_LIST = 'SET_CHILD_GRID_DETAIL_LIST';
export const SET_GOV_GRID_NDC_DETAIL_LIST = 'SET_GOV_GRID_NDC_DETAIL_LIST';
export const SET_CALCULATED_URA_INDEX = 'SET_CALCULATED_URA_INDEX';
export const GET_USER_DEFAULTS = 'GET_USER_DEFAULTS';
export const SET_CALCULATED_URA_ERROR = 'SET_CALCULATED_URA_ERROR';
export const SET_DEFAULT_QTR = 'SET_DEFAULT_QTR';
export const RESET_URA_SEARCH_STORE = 'RESET_URA_SEARCH_STORE';
export const RESET_URA_DETAIL_STORE = 'RESET_URA_DETAIL_STORE';